import { FC } from 'react';
import { Image } from 'antd';
import { ImageProps } from 'antd/lib/image';

const PreviewGroup: FC<ImageProps> = props => {
  const { children, ...restProps } = props;
  return <Image.PreviewGroup {...restProps}>{children}</Image.PreviewGroup>;
};

export default PreviewGroup;
